import React from 'react';
import EditFieldLabel from "./EditFieldLabel";

const DisplayField = React.memo(function DisplayField({
    label,
    value,
    onChange,
    id,
    multiline = false,
    rows = 3,
    ...inputProps
}) {
    const inputId = id ?? `displayfield-${String(label ?? '').toLowerCase().replace(/\s+/g, '-')}`;

    return (
        <>
            <EditFieldLabel label={label} htmlFor={inputId} />
            {multiline ? (
                <textarea
                    id={inputId}
                    className="form-control"
                    value={value}
                    onChange={onChange}
                    rows={rows}
                    {...inputProps}
                />
            ) : (
                <input
                    id={inputId}
                    className="form-control"
                    value={value}
                    onChange={onChange}
                    {...inputProps}
                />
            )}
        </>
    );
});

export default DisplayField;